__webpack_require__.p = "https://gamma.mena.safer.whs.amazon.dev/";